import type { Components, Theme } from "@mui/material/styles";

export const MuiTextField: NonNullable<Components<Theme>["MuiTextField"]> = {
  defaultProps: { variant: "outlined" },
};
